export const EVENTS = {
    startTimer: "startTimer",
    logout: "logout",
    refreshNow: "refreshNow",
    status: "status",
    reinitAmplify: "reinitAmplify",
    tokenChange: "tokenChange",
    pullToken: "pullToken",
    LogoutResponse: "LogoutResponse"
}